import { AbstractListLoader } from './abstract-list-loader';
import { TableSortModel } from '../../tablesort/tableSortModel';
import { LoadingState } from './loading-state';

export class ListLoaderPreloaded<T> extends AbstractListLoader<T> {
  allItems: Array<T>;

  constructor(pageSize, currentPage = 1, allItems: Array<T>, totalItemsFound: number = undefined) {
    super(pageSize);
    this.allItems = allItems;
    this.totalItemsFound = totalItemsFound;
    this.totalItemsVisible = allItems.length;
    this.changePage(currentPage);
  }

  changePage(page: number) {
    if (this.currentPage === page) {
      return;
    }
    this.internalChangePage(page);
  }

  protected internalChangePage(page: number) {
    this.currentPage = page;
    this.stateSubject.next(LoadingState.PAGE_LOADING);
    const start = this.pagerData.startIndex;
    const end = this.pagerData.endIndex;
    const items = this.allItems.slice(start, end);
    this.itemsSubject.next(items);
    this.stateSubject.next(LoadingState.ALL_DATA_LOADED);
  }

  applySortModel(tableSortModel: TableSortModel<T>) {
    this.tableSortModel = tableSortModel;
    const sub = this.tableSortModel.sortedColumns$.subscribe((colModel) => {
      if (!colModel) {
        return;
      }
      this.allItems = colModel.sort(this.allItems);
      this.internalChangePage(this.currentPage);
    });
    this.subscriptions.push(sub);
  }
}
